@if (quote()) {
  <div class="quote">
    @if (quote().text; as text) {
      <blockquote class="citation {{ quoteStyle().textColor | colorClass }}">
        {{ text | truncate: maxLength() }}
      </blockquote>
    }
    @if (quote().legend; as legend) {
      <span class="legend {{ quoteStyle().legendColor ? (quoteStyle().legendColor! | colorClass) : null }}">
        {{ legend }}
      </span>
    }
  </div>
}
